<!-- 图文信息分页展示列表：模块头+图片+标题+分页 -->
<template>
<div class="">
  <table class="avocado-price-table">
    <thead>
    <tr class="">
      <th class="t1">序号</th>
      <th class="t2">规格</th>
      <template v-if="type==2">
        <th class="t2">国别</th>
        <th class="t3">市场</th>
      </template>
      <template v-else>
        <th class="t3">产地</th>
      </template>
      <th class="t4">今日价格</th>
      <th class="t5">昨日价格</th>
      <th class="t6">单位</th>
      <th class="t7">趋势</th>
      <th class="t8">发布时间</th>
      <th class="t9">详情</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(item,index) in pageInfo.list" :key="item.id" @click="handlePriceClick(item)">
      <td>{{index+1}}</td>
      <td>{{item.spec.name}}</td>
      <template v-if="type==2">
        <th >{{item.country}}</th>
      </template>
      <td>{{item.dependency}}</td>
      <td>{{item.today_price}}</td>
      <td>{{item.yesterday_price}}</td>
      <td>{{item.unit}}</td>
      <td v-if="item.daily_change<0" style="color: indianred;">{{item.daily_change}}%↓</td>
      <td v-else style="color: forestgreen;">{{item.daily_change}}%↑</td>
      <td>{{item.date_time}}</td>
      <td>
        <img class="chart-icon" src="../../assets/veg-chart.png" />
      </td>
    </tr>
    <tr style="background-color: #fff;color: #555;" v-if="pageInfo.list.length<1">
      <td colspan="9">{{ loading?'请求中':'暂无数据' }}</td>
    </tr>
    </tbody>
    <div class="mask-loading" v-if="loading"><img src="../../assets/loading.png" class="loading" /></div>
  </table>
  <pagination style="margin-top: 10px;" :page="pageInfo"  v-on:queryData="queryPage"/>
</div>
</template>

<script>
import Pagination from '../utils/Pagination'

export default {
  name: 'AvocadoPriceDataList',
  components: {'pagination': Pagination},
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String | Number,
      default: 1
    },
    pageInfo: {
      type: Object,
      default: function () {
        return {
          list: [],
          page: {
            page: 1,
            pageSize: 10,
            total: 0
          }
        }
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    queryPage (e) {
      this.$emit('pageChange', e)
    },
    handlePriceClick (item) {
      this.$emit('itemClick', item)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mask-loading {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255,255,255,.8);
  display: flex;
  align-items: center;
  justify-content: center;
}
.mask-loading .loading {
  width: 30px;
  height: 30px;
  animation: loadingRotate 2s infinite linear;
  opacity: .6;
}
@keyframes loadingRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.avocado-price-table {
  width: 100%;
  box-sizing: border-box;
  border-spacing: 0;
  border-collapse: collapse;
  position: relative;
}
.avocado-price-table thead {
  height: 50px;
  background: #F5F5F5;
  border-bottom: 2px solid rgb(89,129,24);
}
.avocado-price-table thead th {
  height: 50px;
}
.avocado-price-table tbody tr {
  height: 50px;
  color: rgb(89,129,24);
}
.avocado-price-table tbody tr td {
  cursor: pointer;
  font-weight: 700;
}
.avocado-price-table tbody tr:hover {
  background: #f5f5f5 !important;
}
.avocado-price-table tbody tr:nth-child(odd) {

}
.avocado-price-table tbody tr:nth-child(even) {
  background: rgba(89,129,24,.1);
}

.avocado-price-table .t1 {width: 7%;text-align: center;}
.avocado-price-table .t2 {width: 15%;text-align: center;}
.avocado-price-table .t3 {flex: 1;}
.avocado-price-table .t4 {width: 8%;text-align: center;}
.avocado-price-table .t5 {width: 8%;text-align: center;}
.avocado-price-table .t6 {width: 8%;text-align: center;}
.avocado-price-table .t7 {width: 8%;text-align: center;}
.avocado-price-table .t8 {width: 10%;text-align: center;}
.avocado-price-table .t9 {width: 10%;text-align: center;}
.avocado-price-table .chart-icon {width: 20px;height: 20px;}

.spec-ul {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
  padding: 10px 20px;
  font-size: 18px;
}
.spec-ul span {
  font-weight: 700;
  color: rgb(89,129,24);
}
.spec-ul a {
  color: #333333;
  margin: 0 10px;
  cursor: pointer;
}
.spec-ul a.active, .spec-ul a:hover {
  color: rgb(89,129,24);
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display:block;
  position:relative;
  margin: 0px 0px 0px 0px;
  padding:0px;
  height:100%;
  text-align:left;
  //background:red;
}
.title-search-div{
  position:relative;
  float:right;
  height:30px;
  width:260px;
  background:green;
  bottom:-9px;
}

.title-search-div .title-search-input {
  display: block;
  float: left;
  width: 220px;
  height: 30px;
  outline-style: none;
  border: 1px solid #dbdbdb;
  border-bottom: 0px solid #dbdbdb;
  font-size: 12px;
  padding-left: 5px;
  background:#dbdbdb;
}

.title-search-div .title-search-button {
  display: block;
  float: left;
  width: 40px;
  height: 30px;
  text-decoration: none;
  background: #515151;
  font-size: 12px;
  color:#ffffff;
  text-align: center;
  line-height: 30px;
  letter-spacing:5px;
  background-image:url(./../../assets/search_1.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: center center;
}

.title-search-button:hover{
  cursor: pointer;
  //background-color: #000;
}

.list-tab-ul {
  display:flex;
  justify-content:flex-start;
  margin: 10px auto;
  width:100%;
  height:40px;
  text-align:center;
  list-style-type: none;
  padding: 5px;
  background:#eee;
}

.list-order-ul{
  display:flex;
  justify-content:flex-start;
  margin: 10px auto;
  width:100%;
  height:40px;
  text-align:center;
  list-style-type: none;
  padding: 5px;
  background:#eee;
}

.list-tab-ul-1 {
  display:flex;
  justify-content:flex-start;
  margin: 10px auto;
  width:100%;
  height:50px;
  text-align:center;
  list-style-type: none;
  padding: 5px 5px 15px 0px;
  border-bottom:1px solid #bbb;
}

.list-tab-ul-1 .list-tab-li{
  float: left;
  margin: 0px 20px 0px 0px;
  height: 30px;
  width: 100px;
  color: #000000;
  font-size: 12px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
  background: #598118-#BE550F;
}

.list-tab-li {
  float: left;
  margin: 0px 10px 0px 10px;
  height: 30px;
  width: 100px;
  color: #000000;
  font-size: 12px;
  font-weight: 600;
  line-height: 30px;
  text-align: center;
  background: #598118-#BE550F;
}

.list-order-li-label {
  float: left;
  margin: 0px 10px 0px 10px;
  height: 30px;
  width: 40px;
  color: #000000;
  font-size: 12px;
  font-weight: 300;
  line-height: 30px;
  text-align: left;
  background: #598118-#BE550F;
}

.list-order-li {
  float: left;
  margin: 0px 5px 0px 5px;
  height: 30px;
  width: 50px;
  color: #000000;
  font-size: 12px;
  font-weight: 300;
  line-height: 30px;
  text-align: center;
  background: #598118-#BE550F;
}

.list-order-li-total {
  float: right;
  right:0px;
  margin: 0px 5px 0px 315px;
  height: 30px;
  width: 150px;
  color: #000000;
  font-size: 12px;
  font-weight: 300;
  line-height: 30px;
  text-align: center;
}

.list-tab-li:hover{
  cursor: pointer;
  background:#bbb;
  color:#000;
}

.list-order-li:hover{
  cursor: pointer;
  background:#bbb;
  color:#000;
}

.li-active{
  color: #ffffff!important;
  background: #598118;
  background: -moz-linear-gradient(left,  #598118 50%, #BE550F 100%);
  background: -webkit-gradient(linear, left top, left bottom, color-stop(50%,#BE550F), color-stop(100%,#BE550F));
  background: -webkit-linear-gradient(left,  #598118 f0%,#BE550F 100%);
  background: -o-linear-gradient(left,  #598118 f0%,#BE550F 100%);
  background: -ms-linear-gradient(left,  #598118 f0%,#BE550F 100%);
  background: linear-gradient(to right,  #598118 f0%,#BE550F 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#598118', endColorstr='#BE550F',GradientType=0 );
}

</style>



// WEBPACK FOOTER //
// src/components/block/AvocadoPriceDataList.vue